/* unplugin-vue-components disabled */import script from "./change-self-pwd-form.vue?vue&type=script&setup=true&lang=js"
export * from "./change-self-pwd-form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__